export default "__VITE_ASSET__D0W_94Ki__"